import AutoSubmit from '../components/AutoSubmit'

export default class DesignTeamUsers {
  show() {
    new AutoSubmit();
  }
}
